import React, { useId, useState } from "react";
import { CheckCircle2, ChevronDown, Crown, Sparkles } from "lucide-react";
import { eliteGuides } from "../data/content";
import { Card, CardContent } from "./Card";
import { Reveal } from "./Reveal";
import { SectionHeading } from "./SectionHeading";
import type { EliteGuide } from "../types/content";
function EliteGuideCard({
  guide
}: {
  guide: EliteGuide;
}) {
  const [open, setOpen] = useState(false);
  const contentId = useId();
  return <Card className="overflow-hidden border-[#F5B83D]/45 bg-[#062448] text-white shadow-[0_20px_50px_rgba(0,0,0,0.28)]" data-id="element-66" data-mp="1z9xu76cqacma">
      <div className="flex items-center justify-center gap-2 bg-[linear-gradient(135deg,#A96A16_0%,#F5B83D_48%,#FFD66B_100%)] px-5 py-2.5 text-[#080B14]" data-id="element-67" data-mp="2dzdfw7xejrv4">
        <Sparkles className="size-4" aria-hidden="true" data-id="element-68" data-mp="291u3zeo6fr6c" />
        <span className="text-center text-[11px] font-black uppercase tracking-[0.16em]" data-id="element-69" data-mp="2n0k1gvewrsv8">Incluido comprando hoy</span>
      </div>
      <CardContent className="p-5 sm:p-6" data-id="element-70" data-mp="2izrrfzy7pjxw">
        <button type="button" aria-expanded={open} aria-controls={contentId} onClick={() => setOpen(value => !value)} className="flex w-full items-start gap-3 rounded-lg text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#F5B83D]/50" data-id="element-71" data-mp="2vft3b5p5nm1b">
          <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-[#F5B83D]/10" data-id="element-72" data-mp="39gc7u2uew9yq">
            <Crown className="size-5 text-[#FFD66B]" aria-hidden="true" data-id="element-73" data-mp="3edcbk73sh0mo" />
          </div>
          <div className="min-w-0 flex-1" data-id="element-74" data-mp="3if7hjowo026s">
            <div className="flex items-center justify-between gap-3" data-id="element-75" data-mp="3idwbfifqyici">
              <p className="text-[11px] font-black uppercase tracking-[0.14em] text-[#F5B83D]" data-id="element-76" data-mp="3n80h7yda0kc0">Material {guide.number}</p>
              <span className={`flex size-7 shrink-0 items-center justify-center rounded-full border border-white/10 bg-[#0B3563] transition-transform duration-300 ease-out ${open ? "rotate-180" : ""}`} aria-hidden="true" data-id="element-77" data-mp="3s50sqoswafai">
                <ChevronDown className="size-3.5 text-white" data-id="element-78" data-mp="3cgm5rnfrb3u6" />
              </span>
            </div>
            <h3 className="mt-1 text-base font-black leading-tight text-white sm:text-lg" data-id="element-79" data-mp="37i2hvhhlrhz6">{guide.title}</h3>
            <blockquote className="mt-2 border-l-2 border-[#E3262E] pl-3 text-[13px] italic leading-5 text-[#F7F4EC]" data-id="element-80" data-mp="3m7719204vs8v">
              “{guide.quote}”
            </blockquote>
          </div>
        </button>

        <div id={contentId} className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
        gridTemplateRows: open ? "1fr" : "0fr"
      }} data-id="element-81" data-mp="3v4r4gghk3ym4">
          <div className="overflow-hidden" data-id="element-82" data-mp="8xsslbqw4h0j">
            <ul className="mt-4 space-y-2 pl-[52px]" data-id="element-83" data-mp="4013ephmr901">
              {guide.details.map(detail => <li key={detail} className="flex gap-2 text-sm leading-5 text-[#C7CED8]" data-id="element-84" data-mp="2aq7aiatfplgy">
                  <CheckCircle2 className="mt-0.5 size-4 shrink-0 text-[#27B36A]" aria-hidden="true" data-id="element-85" data-mp="25rdw8g6bpqfq" />
                  {detail}
                </li>)}
            </ul>
          </div>
        </div>
      </CardContent>
    </Card>;
}
export function EliteSection() {
  return <Reveal className="relative overflow-hidden bg-[#080B14] px-5 py-16 sm:px-8 sm:py-20 lg:px-12" data-id="element-86" data-mp="qa95slehnnnk">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[28rem] w-[28rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#F5B83D]/10 blur-3xl" data-id="element-87" data-mp="bhph2ps35ipn" />
      <div className="relative mx-auto max-w-[1180px]" data-id="element-88" data-mp="2hajos1ukd5s">
        <SectionHeading eyebrow="Valor extra incluido HOY" title="Comprando hoy recibís también las Guías Élite sin cargo" subtitle="Dos materiales profesionales incluidos dentro de la oferta completa. Sin pagar ningún extra." data-id="element-89" data-mp="6k74mpev0lcw" />
        <div className="grid gap-4 lg:grid-cols-2" data-id="element-90" data-mp="3tr9bjfkx3m85">
          {eliteGuides.map(guide => <EliteGuideCard key={guide.title} guide={guide} data-id="element-91" data-mp="1mwm988jkgo18" />)}
        </div>
      </div>
    </Reveal>;
}